import * as React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import useAuth from 'features/auth/hooks/use-auth';
import { checkPermissions } from 'utils/check-permissions';
import Forbidden from 'features/auth/components/forbidden';
import ProtectedLayout from 'shared/components/protected-layout';
import EmailVerificationPrompt from 'features/admin-email-verification/components/email-verification-prompt';
import { PropsWithChildren } from 'react';

type Props = {
  redirectPath?: string;
  allowedPermissions?: string[];
};

const ProtectedRoute: React.FC<PropsWithChildren<Props>> = (props) => {
  const { state } = useAuth();
  const location = useLocation();

  if (!state.isAuth) {
    return (
      <Navigate
        to={ROUTES.dynamic.signIn()}
        state={{ from: location.pathname + location.search }}
        replace
      />
    );
  }

  if (state.isEmailVerificationRequired && !state.isEmailVerified) {
    return (
      <ProtectedLayout>
        <EmailVerificationPrompt />
      </ProtectedLayout>
    );
  }

  const permitted = checkPermissions({
    allowedPermissions: props.allowedPermissions || [],
    userPermissions: state.permissions,
  });
  if (!permitted && props.redirectPath) {
    return <Navigate to={props.redirectPath} />;
  }

  if (!permitted) {
    return (
      <ProtectedLayout>
        <Forbidden />
      </ProtectedLayout>
    );
  }

  return <ProtectedLayout>{props.children ?? <Outlet />}</ProtectedLayout>;
};

export default ProtectedRoute;
